import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
var propTypes = {
  /**
   * If true, custom superscript styles will be applied
   */
  superscriptSmall: PropTypes.bool,

  /**
   * @ignore
   */
  config: PropTypes.object
};
var StyledSuper = /*#__PURE__*/styled.sup.withConfig({
  displayName: "StyledSuper",
  componentId: "sc-1fkq1x2-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref) {
  var superscriptconfig = _ref.superscriptconfig;
  return superscriptconfig && "\n    position: relative;\n    font-size: ".concat(superscriptconfig.fontSize / 2, "px;\n    line-height: 0px;\n    font-family: ").concat(superscriptconfig.fontFamily, ";\n  ");
});

var Super = function Super(props) {
  var fontConfig = props.fontConfig,
      children = props.children,
      superscriptSmall = props.superscriptSmall;
  var Wrapper = superscriptSmall ? StyledSuper : 'span';
  var stringifiedChildren = children.toString();

  function _convertToUnicode(_char) {
    _char = _char.toString();

    switch (_char) {
      case '0':
        return "\u2070";

      case '1':
        return "\xB9";

      case '2':
        return "\xB2";

      case '3':
        return "\xB3";

      case '4':
        return "\u2074";

      case '5':
        return "\u2075";

      case '6':
        return "\u2076";

      case '7':
        return "\u2077";

      case '8':
        return "\u2078";

      case '9':
        return "\u2079";

      default:
        return superscriptSmall ? _char : /*#__PURE__*/React.createElement("sup", null, " char ");
    }
  }

  function _parseChildren(children) {
    return _toConsumableArray(children).map(function (_char2) {
      return _convertToUnicode(_char2);
    });
  }

  if (typeof children !== 'string' && typeof children !== 'number') {
    console.warn('Super element only allows children of type string or number.');
    return null;
  }

  return /*#__PURE__*/React.createElement(Wrapper, {
    superscriptconfig: fontConfig
  }, _parseChildren(stringifiedChildren));
};

Super.propTypes = propTypes;
Super.displayName = 'Super';
export default Super;